.labelContainer {
  position: relative;
  display: flex;
  flex-direction: column;
}

.dot {
  position: relative;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  margin-top: 8px;
  margin-bottom: 8px;
}

.noteLabel {
  font-size: 0.8rem;
}
